import { render, staticRenderFns } from "./InvitationHome.vue?vue&type=template&id=1b5ce934&"
import script from "./InvitationHome.vue?vue&type=script&lang=js&"
export * from "./InvitationHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports